/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-debugger */
import { useState, useEffect } from 'react';
// material
import { Card, Container } from '@material-ui/core';
import useSettings from 'src/hooks/useSettings';
import TableSearch from 'src/components/table/TableSearch';
import { HEADER_LIST_HEAD } from 'src/constants/Dashboard';
// redux
import { useSnackbar } from 'notistack5';
import {
  filterHeader,
  deleteHeader,
  statusChange,
  resetCreateHeaderStatus,
  resetHeaderMsg
} from 'src/redux/slices/header';
import { useDispatch, useSelector } from 'src/redux/store';
import AlertDialog from 'src/components/common-components/AlertDialog';

// ----------------------------------------------------------------------

export default function HeaderList({
  setEditId,
  headerListStatus,
  setHeaderListStatus,
  headerList,
  deleteId,
  setDeleteId,
  loading
}) {
  const { themeStretch } = useSettings();
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const [close, setClose] = useState(false);
  const [title, setTiltle] = useState('');
  const [content, setContent] = useState('');
  const dispatch = useDispatch();
  const { createHeaderStatus, headerMsg } = useSelector((state) => state.header);

  useEffect(() => {
    if (createHeaderStatus) {
      enqueueSnackbar('Header Disabled Successfully', { variant: 'success' });
      dispatch(resetCreateHeaderStatus());
    }
    if (headerMsg) {
      setClose(true);
      setOpen(true);
      dispatch(resetHeaderMsg());
      setTiltle('Disable Header');
      setContent(headerMsg);
    }
  }, [headerMsg, createHeaderStatus]);

  const handleHeaderListSwitch = (e) => {
    setHeaderListStatus(!e.target.checked);
  };

  const handleDelete = (id) => {
    setClose(false);
    setTiltle('Delete Header?');
    setContent('Are you sure want to delete header data permanently??');
    setOpen(true);
    setDeleteId(id);
  };

  const handleDeleteDispatch = () => {
    dispatch(deleteHeader(deleteId));
    enqueueSnackbar('Header Deleted Successfully', {
      variant: 'success'
    });
    setOpen(false);
  };

  const handleDisable = async (id) => {
    dispatch(statusChange(id, false));
  };

  const handleRestore = async (id) => {
    dispatch(statusChange(id, true));
    enqueueSnackbar('Header Restore Successfully', {
      variant: 'success'
    });
  };

  const handleEdit = (id) => {
    setEditId(id);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Container maxWidth={themeStretch ? false : 'lg'} style={{ padding: 0 }}>
      <Card>
        <AlertDialog
          title={title}
          content={content}
          okFunction={close ? handleClose : handleDeleteDispatch}
          open={open}
          setOpen={setOpen}
        />
        <TableSearch
          tableHead={HEADER_LIST_HEAD}
          tableData={headerList}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          handleDisable={handleDisable}
          handleRestore={handleRestore}
          status={headerListStatus}
          switchButton
          filterComponent={filterHeader}
          switchButtonResponse={handleHeaderListSwitch}
          loading={loading}
        />
      </Card>
    </Container>
  );
}
